import { rgba } from "polished";
import throwError from "../throwError";

/**
 * Returns color (defined in theme object)
 *
 * @param theme - Theme object
 * @param color - Color name which is located in theme
 * @param state - State of a styling element
 * @returns Color from theme
 */
var getColor = function getColor(theme, color) {
  var _theme$colors$color;
  var state = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "default";
  var customEmphasis = arguments.length > 3 ? arguments[3] : undefined;
  var colorValue = (_theme$colors$color = theme.colors[color]) === null || _theme$colors$color === void 0 ? void 0 : _theme$colors$color.color;
  if (!colorValue) {
    throwError("Passed \"".concat(colorValue, "\" color isn't defined in theme!"));
  }
  if (typeof customEmphasis === "number") {
    return rgba(colorValue, customEmphasis);
  }
  if (state === "hover") {
    return rgba(colorValue, 0.8);
  }
  return colorValue;
};
export default getColor;